import React, { useState } from 'react';
import { TabsUI } from '../Interface';
import ConfigFields from './ConfigFields';
import GeneralSettingFields from './GeneralSettingFields';
import ProductionSettingFields from './ProductionSettingFields';
import PartnerSettingFields from './PartnerSettingFields';
import KanbanSettingFields from './KanbanSettingFields';
import ServiceSettingFields from './ServiceSettingFields';
import ExchangeRateSettingFields from './ExchangeRateSettingFields';
import FinancialSettingFields from './FinancialSettingFields';
import ProjectAndTaskSettingFields from './ProjectAndTaskSettingFields';

const ConfigTabs = (props) => {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      id: 0,
      name: 'Saját cég adatok',
      content: <ConfigFields {...props} />,
    },
    {
      id: 1,
      name: 'Általános beállítások',
      content: <GeneralSettingFields {...props} />,
    },
    {
      id: 2,
      name: 'Gyártás beállítások',
      content: <ProductionSettingFields {...props} />,
    },
    {
      id: 3,
      name: 'Partner beállítások',
      content: <PartnerSettingFields {...props} />,
    },
    {
      id: 4,
      name: 'Folyamat monitor beállítások',
      content: <KanbanSettingFields {...props} />,
    },
    {
      id: 5,
      name: 'Szervíz beállítások',
      content: <ServiceSettingFields {...props} />,
    },
    {
      id: 6,
      name: 'Árfolyam beállítások',
      content: <ExchangeRateSettingFields {...props} />,
    },
    {
      id: 7,
      name: 'Pénzügyi beállítások',
      content: <FinancialSettingFields {...props} />,
    },
    {
      id: 8,
      name: 'Projekt és feladat beállítások',
      content: <ProjectAndTaskSettingFields {...props} />,
    },
  ];

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <div className="my-4 mt-6">
      <div className="px-3">
        <TabsUI activeTab={activeTab} handleTabClick={handleTabClick}>
          {tabs.map((tab, index) => (
            <div key={index} name={tab.name}>
              {tab.content}
            </div>
          ))}
        </TabsUI>
      </div>
    </div>
  );
};

export default ConfigTabs;
